import * as React from 'react'

interface Props {
    message?: {
        args: {
            totalQueries: number
        }
    }
}

export default class SlowMySQL extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        let numQueries = <span></span>
        if (message) {
            numQueries = <strong>{' ' + message.args.totalQueries.toString()}</strong>
        }

        return (
            <div>
                <p>This trace shows slow or repeated SQL calls:</p>

                <p>
                    More than 95% of all{numQueries} queries in this trace took longer than 5ms. This is a strong indicator that there is a
                    general problem in the database server that needs to be addressed.
                </p>
                <p>
                    Usually MySQL can respond in sub-milliseconds to queries that use a primary key or any other index and seeing so little
                    queries in that range is alarming.
                </p>
                <p>You could check the following things to find a solution:</p>
                <ol>
                    <li>
                        <strong>Resource Constraints:</strong> MySQL Database does not have enough CPU, RAM or fast enough disks. You can
                        check this by looking at resource metrics of your database server:
                        <ol>
                            <li>Average Load shown in “top” should be below the number of cores.</li>
                            <li>
                                Available RAM should allow MySQL server to hold all the hot data in InnoDB buffer pool. See size of all
                                active tables and compare to InnoDB buffer pool size. Check the Buffer Pool hit ratio.
                            </li>
                            <li>
                                Using “iotop” you can check how much MB/s is written to disk. If this adds up to high double or triple digit
                                MB/s then this might be close to what your disk can achieve at the maximum.
                            </li>
                        </ol>
                    </li>
                    <li>
                        <strong>Configuration Constraints:</strong> Even though the RAM could be high for MySQL server, if you don’t
                        configure InnoDB Buffer pool size to use most of the servers memory (70%-80%), then you can see problematic
                        performance.
                    </li>
                    <li>
                        <strong>Network constraints:</strong> Especially with database on cloud platforms, the database could be too far
                        away from the application server(s) in terms of network distance to achieve quick queries. Furthermore with network,
                        if your application fetches a large amount of data every request from the database, the network could be reaching
                        the limit with all the data transmitted between database and application servers.
                    </li>
                    <li>
                        <strong>Slow SQL Queries with no or bad indexes:</strong> Instead of a server problem, this really could be a
                        problem of most SQL queries in this request using no or bad indexes.
                    </li>
                </ol>
            </div>
        )
    }
}
